import { render, staticRenderFns } from "./MarketplaceGridList.vue?vue&type=template&id=4f0c0edc&scoped=true&"
import script from "./MarketplaceGridList.vue?vue&type=script&lang=js&"
export * from "./MarketplaceGridList.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceGridList.vue?vue&type=style&index=0&id=4f0c0edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c0edc",
  null
  
)

export default component.exports